import {
  AdminAssessmentListProps,
  AssessmentStage,
  PracticeAssessmentListProps,
  PracticeAssessmentStage,
} from '../types'

export const pregnancyStageFilterFields: Record<AssessmentStage, keyof AdminAssessmentListProps> = {
  Inquiry: 'onInquiryList',
  Authorization: 'onAuthList',
  'Consent Forms': 'onOtherList',
  'Send Claim': 'onSendClaimList',
  Claims: 'onClaimsList',
  Complaints: 'onComplaintsList',
  Complete: 'onCompleteList',
}

// practice pregnancies re-use some of the admin assessment snippet fields for less firestore indexes
export const practicePregnancyStageFilterFields: Record<
  PracticeAssessmentStage,
  keyof PracticeAssessmentListProps
> = {
  Inquiry: 'onInquiryList',
  Current: 'onAuthList',
  Postpartum: 'onSendClaimList',
  Gyn: 'onGynList',
  Other: 'onOtherList',
  Complete: 'onCompleteList',
  Discharged: 'onDischargedList',
}
